import * as React from "react";

interface Props {
  viewBox?: string;
  color: string;
  size: string;
}

export const ProductSala = (props: Props) => (
  <svg
    width={props.size}
    height={props.size}
    viewBox={props?.viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5.35h-.65V8.153h11.705V.35H11.5Zm.65 6.503V1.65h9.105v5.203H12.15Zm4.779 2.256a4.5 4.5 0 0 1 4.47 3.972 1.783 1.783 0 0 1 1.156 1.67v4.188H21.72l.311.518a.5.5 0 1 1-.858.515l-.619-1.033H2.331l-.498.997a.5.5 0 1 1-.894-.447l.275-.55H.445v-4.188c0-.75.464-1.392 1.12-1.655a4.505 4.505 0 0 1 2.944-3.72h-.877V4.901H1.514l.261-.843L2.785.807 2.925.35h2.841l.142.457L6.92 4.06l.261.843H4.932v4.344c.353-.09.723-.137 1.104-.137H16.93Zm0 1a3.5 3.5 0 0 1 3.45 2.903c-.762.171-1.338.83-1.387 1.63H4.008a1.784 1.784 0 0 0-1.419-1.637 3.501 3.501 0 0 1 3.448-2.896H16.93Zm3.36 5.182v2.348h.966v-2.888a.483.483 0 0 0-.966-.01v.55Zm-16.278.65h14.978v1.178a3.485 3.485 0 0 1-1.044.52H5.02a3.486 3.486 0 0 1-1.01-.495V15.94Zm-2.266-1.19a.483.483 0 1 1 .966 0v2.888h-.966v-2.888ZM3.884 1.65l-.606 1.952h2.137L4.81 1.65h-.926Z"
      fill={props.color}
    />
  </svg>
);
